import React, { useEffect } from 'react';
import { faOnMessageClose, faOnMessageShown } from './analytics-services';
import './infoStrip.css';

const InfoStrip = ({
  message = '',
  bgColorClass = '',
  classes = '',
  iconClass = '',
  closeBtnHandler = null,
  showArrow = true,
  omnitureClick,
  type = 'GENERIC',
}) => {
  const onClose = e => {
    closeBtnHandler(e);
    if (omnitureClick) {
      faOnMessageClose(type);
      omnitureClick(`Message_close_${type}`);
    }
  };

  useEffect(() => {
    if (omnitureClick) {
      faOnMessageShown(type);
      omnitureClick(`Message_shown_${type}`);
    }
  }, []);

  return (
    <div className={`${bgColorClass} ${classes}`}>
      <div className={`cityChangeWarningWrapper ${showArrow ? 'show-arrow' : ''}`}>
        {iconClass !== '' && <span className={`holidaySprite ${iconClass}`} />}
        {message !== '' && <p className="cityChangeWarningText">{message}</p>}
        {closeBtnHandler && <span className="cityChangeWarningCloseIcon" onClick={onClose} />}
      </div>
    </div>
  );
};

export default InfoStrip;
